import { publicApi } from '../lib/api'
import type { ProCategory, ProsDiscoverParams, ProsDiscoverResponse } from '../types/pros'

export async function discoverPros(params: ProsDiscoverParams = {}): Promise<ProsDiscoverResponse> {
  const { data } = await publicApi.get<ProsDiscoverResponse>('/api/pros/discover/', { params })
  return {
    results: Array.isArray(data?.results) ? data.results : [],
    page: Number(data?.page || params.page || 1),
    page_size: Number(data?.page_size || params.page_size || 12),
    has_next: Boolean(data?.has_next),
    sort: (data?.sort || params.sort || 'newest') as ProsDiscoverResponse['sort'],
  }
}

export async function listProsCategories(): Promise<ProCategory[]> {
  const { data } = await publicApi.get<{ categories?: ProCategory[] }>('/api/pros/categories/')
  return Array.isArray(data?.categories) ? data.categories : []
}
